import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BsChatLeftTextFill } from 'react-icons/bs';
import { Palette } from '../components/utils';
import ChatPanel from '../views/chat/ChatPanel';
import { HeaderNavButtonIcon, HeaderNavButtonIconBadge } from './HeaderComponents';
import { useChatEnabled } from '../hooks/useChatEnabled';

const TheHeaderChat = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasUnread = useSelector((state) => Boolean(state.chat?.hasUnread));
  const chatEnabled = useChatEnabled();

  if (!chatEnabled) {
    return null;
  }

  return (
    <>
      <ChatNavButton
        type="button"
        aria-label={t('Messages')}
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <HeaderNavButtonIcon>
          <BsChatLeftTextFill size={22} />
        </HeaderNavButtonIcon>
        {hasUnread && (
          <HeaderNavButtonIconBadge
            aria-label={t('Unread messages')}
            cssOverride={`background-color: ${Palette.CYAN_500};`}
          />
        )}
      </ChatNavButton>
      <ChatPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
};

const ChatNavButton = styled.button`
  display: inline-flex;
  background-color: ${Palette.SOLITUDE};
  border: none;
  border-radius: 10px;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  margin: 0 0.5rem;
  cursor: pointer;
  padding: 0;

  :hover {
    background-color: rgba(117, 117, 117, 0.2);
  }

  :focus {
    outline: none;
  }
`;

export default React.memo(TheHeaderChat);
